// extracted by mini-css-extract-plugin
export default {"desp":"RuleText_desp__RlGzL"};